function AddressAndContact({ phone, email, location, address }) {
  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-200 transition-all duration-300 hover:shadow-lg">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 tracking-tight">
          Adres ve İletişim
        </h2>
        <div className="space-y-6">
          <div>
            <p className="text-gray-700 font-medium flex items-center gap-2">
              <span className="text-[#6ca87e]">📍</span> Adres
            </p>
            <p className="text-gray-600 mt-1 leading-relaxed">{address}</p>
          </div>
          {/* <div>
            <p className="text-gray-700 font-medium flex items-center gap-2">
              <span className="text-[#6ca87e]">📞</span> Telefon
            </p>
            <p className="text-gray-600 mt-1">{phone}</p>
          </div> */}
          <div>
            <p className="text-gray-700 font-medium flex items-center gap-2">
              <span className="text-[#6ca87e]">✉️</span> E-posta
            </p>
            <p className="text-gray-600 mt-1">{email}</p>
          </div>
        </div>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full bg-[#4d9041] text-white font-semibold py-3 px-4 rounded-lg shadow-md hover:bg-[#62a556] transition-all duration-300 transform hover:scale-105 text-center mt-6"
        >
          Yol tarifi al
        </a>
      </div>
    </div>
  );
}

export default AddressAndContact;
